import ProfileImg from '@core/components/ProfileImg';
import Route from '@core/components/Route';
import Typography from '@mui/material/Typography';
import Grid2 from '@shared/components/Grid2';
import { H2, H3 } from '@shared/components/Heading';
import List from '@shared/components/List';
import ListItem from '@shared/components/ListItem';
import { FC, memo } from 'react';

import { InstructorTemplateProps } from '../types/instructor-template';
import { COLOR } from '../types/theme';
import { colorToCss } from '../utils/theme';
import GenericLayout from './GenericLayout';
import NoPageImageSection from './NoPageImageSection';

const InstructorTemplate: FC<InstructorTemplateProps> = ({
  cv,
  img,
  name,
  school,
  systema,
  vision,
}) => (
  <GenericLayout title={name}>
    <NoPageImageSection background={colorToCss(COLOR.Dark3)}>
      <Grid2 spacing={{ md: '2rem', xs: '1.5rem' }}>
        <Grid2.Centered>{img && <ProfileImg alt={img.alt} src={img.src} />}</Grid2.Centered>
        <Grid2.Item>
          <H2 color={COLOR.Gold1}>{name}</H2>

          {vision && (
            <Typography component='blockquote' sx={{ marginY: '1.5em' }}>
              {vision}
            </Typography>
          )}

          <H3>Standort</H3>
          <List bullets>
            <ListItem>
              {school.url ? <Route href={school.url}>{school.name}</Route> : school.name}
            </ListItem>
          </List>

          <H3 margin={{ top: '1.5rem' }}>Systema</H3>
          <List bullets itemProps={{ margin: '0' }}>
            {systema.map((element, index) => (
              <ListItem key={index}>{element}</ListItem>
            ))}
          </List>

          {cv && (
            <>
              <H3 margin={{ top: '1.5rem' }}>Sonstiges</H3>
              <List bullets itemProps={{ margin: '0' }}>
                {cv.map((text, index) => (
                  <ListItem key={index}>{text}</ListItem>
                ))}
              </List>
            </>
          )}
        </Grid2.Item>
      </Grid2>
    </NoPageImageSection>
  </GenericLayout>
);

export default memo(InstructorTemplate);
